<template>
  <div v-html="dagreement.content"></div>
</template>

<script>
export default {
  data() {
    return {
      dagreement: {},
      textHtml: "",
    };
  },
  async created() {
    let res = await this.$apis.extendServe.getExtendAgreement();
    if (res.resultCode === "200") {
      this.dagreement = res.content.detail[0];
    }
  },
};
</script>

<style>
</style>